<template>
  <div class="marketing">
    <portal to="sticky-component" tag="div" name="sticky-component">
      <div class="tab-wrap tab-marketing">
        <tab-item :list="tab.list" :name="tab.name" v-model="tab.active" />
      </div>
    </portal>
    <div class="key-visual">
      <div class="mask">
        <div class="contents">
          <div class="txt">
            <span>e·motion global</span>은<br />
            <span>e·very brand</span>가 원하는<br />
            <span>e·xclusive solution</span>을 제공합니다
          </div>
        </div>
        <div class="bg"></div>
      </div>
    </div>

    <div class="tab-contents">
      <div class="marketing-wrap">
        <!-- Brand Marketing [S] -->
        <div class="marketing-inner" v-show="tab.active === 'brandMarketing'">
          <div class="contents">
            <h3 class="cont-title">
              정교한 분석과 혁신적 솔루션으로<br />
              브랜드의 잠재력을 극대화하는<br />
              차별화된 경험을 창조해냅니다.
            </h3>

            <!-- 임시 이미지 -->
            <!--<div class="cont-img">
              <img src="@/assets/images/marketing/lottie.png" alt="" />
            </div>-->

            <!-- 로띠 -->
            <div class="cont-img lottie-cont lottie01">
              <lottie-marketing01 />
            </div>

            <section class="section section-1">
              <h3 class="section-tit">
                Brand Marketing
              </h3>
              <p class="section-desc">
                퍼포먼스 마케팅 저성장 시대에 무엇보다 고객이 공감하고 몰입이 가능한 경험을 제공할 수 있는<br />
                브랜드 마케팅을 위한 research · planning · bx design · guidance · action 프로세스로 제시합니다.
              </p>
              <div class="process-cont">
                <div class="tit-wrap">
                  <p>Marketing Process</p>
                </div>
                <div class="li-wrap">
                  <ul>
                    <li>
                      <p class="li-tit"><span>01</span>Research</p>
                      <img src="@/assets/images/marketing/brand01.png" alt="Research" />
                      <p class="li-desc">
                        브랜드와 시장, 경쟁사에 대한 기초 조사를 통해 핵심 인사이트와 전략 수립의 기반을 마련합니다.<br/>
                        브랜드의 본질을 파악하고 방향성을 설정하는 출발점입니다.
                      </p>
                    </li>
                    <li>
                      <p class="li-tit"><span>02</span>Planning</p>
                      <img src="@/assets/images/marketing/brand02.png" alt="Planning" />
                      <p class="li-desc">
                        브랜드의 방향성과 구조를 정리하고 디자인 원칙과 체계를 명확히 설정하고, 체계적인 전략 수립으로 일관된 실행을 위한 기틀을 만듭니다.
                      </p>
                    </li>
                    <li>
                      <p class="li-tit"><span>03</span>BX design</p>
                      <img src="@/assets/images/marketing/brand03.png" alt="BX design" />
                      <p class="li-desc">
                        언어적‧시각적 자산을 개발해 브랜드의 표현력을 강화하고 디자인 시스템을 통해 일관된 사용자 경험을 설계합니다. 브랜드의 개성을 구체화하고 시각적으로 전달하는 핵심 단계입니다.
                      </p>
                    </li>
                    <li>
                      <p class="li-tit"><span>04</span>Guidance</p>
                      <img src="@/assets/images/marketing/brand04.png" alt="Guidance" />
                      <p class="li-desc">
                        브랜드 활용 기준을 정리한 가이드라인을 제작하여 내부 운영과 외부 커뮤니케이션의 일관성을 확보합니다. 이를 통해 이해관계자들이 브랜드를 이해하고 활용할 수 있도록 돕습니다.
                      </p>
                    </li>
                    <li>
                      <p class="li-tit"><span>05</span>Action</p>
                      <img src="@/assets/images/marketing/brand05.png" alt="Action" />
                      <p class="li-desc">
                        정립된 브랜드 자산을 다양한 접점에 적용하여 실질적인 브랜드 경험을 구현합니다. 현장 중심의 실행으로 브랜드의 가치를 현실화합니다.
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </section>
          </div>
        </div>
        <!-- Brand Marketing [E] -->

        <!-- Creative Campaign [S] -->
        <div class="marketing-inner" v-show="tab.active === 'creativeCampaign'">
          <div class="contents">
            <section class="section section-1">
              <h3 class="section-tit">
                Creative Campaign
              </h3>
              <p class="section-desc">
                브랜드의 pain point를 캐치하고 기존 데이터에 기반한 인사이트를 도출하여 고객 집착적인 컨셉 및 메시지,<br />캠페인 전략을 산출하고, 디지털부터 OOH까지 고객이 자발적 바이럴을 끌어낼 수 있는 캠페인을 전개합니다.
              </p>
              <div class="section-img">
                <img src="@/assets/images/marketing/create01.png" alt="Creative Campaign 프로세스" />
              </div>
            </section>
            <!--<section class="section section-1">
              <h3 class="section-tit">
                정교한 분석과 혁신적 솔루션으로<br />
                브랜드의 잠재력을 극대화하는
              </h3>
            </section>-->
          </div>
          <section class="swiper-section" ref="swiperSection">
            <swiper class="swiper-container" :options="swiperOptions">
              <swiper-slide
                v-for="(item, index) in swiperData"
                :key="index"
                :style="`background: url(${item.bgImg}) center / cover no-repeat`"
              >
                <div class="inner">
                  <div
                    class="logo swiper-text"
                    :style="`background: url(${item.logoImg}) 0 0 / cover no-repeat`"
                  >
                    {{ item.title }}
                  </div>
                  <div class="right">
                    <h3 class="title swiper-text">
                      <strong v-html="item.title_1"></strong>
                      {{ item.title_2 }}
                    </h3>
                    <p class="sm-tit swiper-text">
                      {{ item.sm_tit }}
                    </p>
                    <p class="sm-txt swiper-text">
                      {{ item.sm_txt }}
                    </p>
                  </div>
                </div>
              </swiper-slide>
            </swiper>
            <div class="swiper-button-next">
              <img src="@/assets/images/consulting/ic_nav.svg" alt="swiper_arrow" />
            </div>
            <div class="swiper-button-prev">
              <img src="@/assets/images/consulting/ic_nav.svg" alt="swiper_arrow" />
            </div>
          </section>
        </div>
        <!-- Creative Campaign [E] -->

        <!-- AD Marketing [S] -->
        <div class="marketing-inner" v-show="tab.active === 'adMarketing'">
          <div class="contents">
            <section class="section section-1">
              <h3 class="section-tit">
                AD Marketing
              </h3>
              <p class="section-desc">
                고객 데이터와 최신 트렌드를 기반으로 맞춤 전략을 실행하여, 광고 성과를 극대화하고 꾸준한 잠재 고객 유입과 구매 전환으로<br />비즈니스 효율을 향상시킵니다.
              </p>
              <div class="section-img">
                <img src="@/assets/images/marketing/ad01.png" alt="AD Marketing 비지니스 효율" />
              </div>
            </section>
          </div>
        </div>
        <!-- AD Marketing [E] -->

        <!-- AI Studio [S] -->
        <div class="marketing-inner" v-show="tab.active === 'aiStudio'">
          <div class="contents">
            <section class="section section-1">
              <h3 class="section-tit">
                AI Studio
              </h3>
              <p class="section-desc">
                브랜드에 내재된 고유한 비주얼 자산을 분석한 데이터를 기반으로 영상, 이미지, 모델 등 AI 제너레이팅 툴을 통해<br />
                기존 광고, 숏폼 콘텐츠를 카테고리별 프롬프트 스토리텔링과 결합하여 새로운 유형의 콘텐츠로 구현합니다.
              </p>
              <div class="section-img">
                <img src="@/assets/images/marketing/ai01.png" alt="AI Studio 프로세스" />
              </div>
            </section>
          </div>
        </div>
        <!-- AI Studio [E] -->
      </div>
    </div>
  </div>
</template>
<script>
  import {Swiper, SwiperSlide} from "vue-awesome-swiper";
  import "swiper/css/swiper.css";
  import {Power0} from "gsap";
  import {mapGetters} from "vuex";
  import LottieMarketing01 from "@/components/lottie/marketing01.vue";
  import {TweenMax, Power2} from "gsap";

  export default {
    name: "marketing",
    components: {LottieMarketing01, Swiper, SwiperSlide},
    metaInfo() {
      return {
        title: "Marketing",
        titleTemplate: "%s | e · motion",
        meta: [
          {
            property: "og:title",
            content: "marketing | e · motion",
            vmid: "og:title"
          },
          {
            property: "og:url",
            content: "https://www.emotion.co.kr/marketing/",
            vmid: "og:url"
          }
        ]
      };
    },
    data() {
      return {
        tab: {
          name: "tab",
          list: [
            {
              id: "brandMarketing",
              title: "Brand Marketing"
            },
            {
              id: "creativeCampaign",
              title: "Creative Campaign"
            },
            {
              id: "adMarketing",
              title: "AD Marketing"
            },
            {
              id: "aiStudio",
              title: "AI Studio"
            }
          ],
          active: "brandMarketing"
        },

        isOpen: false,
        scrollPosition: 0,
        isOpen2: false,
        scrollPosition2: 0,
        testData: false,
        isModalOpen: false,

        swiperData: [
          {
            title: "DORCO",
            bgImg: require("@/assets/images/marketing/swiper_bg_01.png"),
            logoImg: require("@/assets/images/marketing/swiper_logo_dorco.png"),
            title_1: "도루코 바버샵",
            title_2: "버스 캠페인",
            sm_tit: "Marketing",
            sm_txt:
              "남자들을 위한 특별한 서비스를 경험할 수 있는 프로젝트로서 도루코 바버샵 브랜드 사이트에서 진행된 이벤트를 통해 ‘특별한 날’이 필요한 사연을 받아 신청자들 중 매주 1명씩 선발하여 전문 바버의 쉐이빙 서비스를 직접 경험하게 하고, 그들만의 특별한 날을 선물하는 프로모션을 진행했습니다."
          },
          {
            title: "LG U+",
            bgImg: require("@/assets/images/marketing/swiper_bg_02.png"),
            logoImg: require("@/assets/images/marketing/swiper_logo_lgU.png"),
            title_1: "LG U+ tv G 우퍼",
            title_2: "바이럴 영상 캠페인",
            sm_tit: "Marketing",
            sm_txt:
              "황치열, 홍대 기타 여신 리싸와 함께 90년대 메가 히트곡인 솔리드의 ‘이 밤의 끝을 잡고’를 모던 록으로 리메이크한 뮤직비디오를 제작, 뮤직비디오 속 두 명의 모델과 함께 LG U+ tv G 우퍼를 지속적으로 노출하고, 콘서트의 감동을 집안에서도 누릴 수 있다는 키 메시지를 전달하였습니다."
          },
          {
            title: "Popeyes",
            bgImg: require("@/assets/images/marketing/swiper_bg_03.png"),
            logoImg: require("@/assets/images/marketing/swiper_logo_popeyes.png"),
            title_1: "파파이스",
            title_2: "디지털 캠페인",
            sm_tit: "Marketing",
            sm_txt:
              "파파이스는 브랜드 정체성 강화와 고객 접점 확대를 위해 전국 매장에서 '스파이시 걸' 선발 프로모션을 디지털 플랫폼과 연계하여 대규모로 진행하였습니다. 이 캠페인은 오프라인 이벤트와 온라인 참여를 결합하여 소비자들의 자발적 참여와 함께 파파이스 브랜드 경험 전달을 극대화하였습니다."
          }
        ],
        swiperOptions: {
          loop: true,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
          }
        },
        isExpanded: false
      };
    },
    mounted() {
      this.initSwiperPosition();
      window.addEventListener("scroll", this.handleScroll);
    },
    beforeDestroy() {
      window.removeEventListener("scroll", this.handleScroll);
    },
    provide() {
      const my = {};
      Object.defineProperty(my, "testData", {
        enumerable: true,
        get: () => this.testData
      });
      return {my};
    },
    computed: {
      ...mapGetters(["GE_CONT_HEIGHT"])
    },
    watch: {
      GE_CONT_HEIGHT() {
        if (this.$el.offsetParent) {
          this.init();
          this.tabFixed();
        }
      }
    },
    $route() {
      let y = window.scrollY;
      let tabY = document.querySelector(".tab-contents").offsetTop;
      if (tabY < y) {
        window.scrollTo({top: tabY + 1});
      }
    },
    isValid() {
      if (this.isValid) {
        this.isError = false;
      }
    },

    activated() {
      this.tabFixed();
    },
    methods: {
      init() {
        this.scene1?.destroy(true);
        const keyVisual = document.querySelector(".key-visual");
        const tween = TweenMax.to(keyVisual.querySelector(".bg"), 1, {
          y: keyVisual.clientHeight,
          ease: Power0.easeInOut
        });
        const tween2 = TweenMax.to(keyVisual.querySelector(".txt"), 1, {
          y: keyVisual.clientHeight + keyVisual.querySelector(".txt").clientHeight,
          ease: Power0.easeInOut
        });
        this.scene1 = this.$scrollmagic
          .scene({
            triggerElement: keyVisual,
            triggerHook: 0,
            duration: keyVisual.clientHeight * 2
          })
          .setTween([tween, tween2]);
        this.$scrollmagic.addScene(this.scene1);
      },
      /* // 탭 고정 */
      tabFixed() {
        const item = document.querySelector(".tab-top");
        const contents = document.querySelector(".tab-contents");
        if (item.style.position === "fixed") return;
        const scene1 = this.$scrollmagic
          .scene({
            triggerElement: item,
            triggerHook: 0.1,
            duration: contents.clientHeight - "100vh" || 0
          })
          .setPin(item)
          .setClassToggle(".tab-top", "flex-end");
        this.$scrollmagic.addScene(scene1);
        /* // 탭 고정 */
      },
      initSwiperPosition() {
        const swiperSection = this.$refs.swiperSection;
        if (swiperSection) {
          TweenMax.set(swiperSection, {
            width: "100%",
            height: "100vh",
            position: "relative",
            margin: "0 auto",
            clipPath: "inset(35% 15% 35% 15%)"
          });
        }
      },
      handleScroll() {
        const scrollY = window.scrollY || window.pageYOffset;
        const swiperSection = this.$refs.swiperSection;
        if (swiperSection) {
          const sectionTop = swiperSection.offsetTop;
          const swiperHeight = window.innerHeight;
          const startScroll = sectionTop - swiperHeight;
          const progress = Math.min(1, Math.max(0, (scrollY - startScroll) / swiperHeight));
          const inset = 35 - 35 * progress;

          TweenMax.to(swiperSection, 1, {
            clipPath: `inset(${inset}% ${inset / 2}% ${inset}% ${inset / 2}%)`,
            ease: Power2.easeOut,
            onUpdate: () => {
              // console.log("progress", progress);
              if (progress >= 0.5) {
                this.isExpanded = true;
                document.querySelectorAll(".swiper-text").forEach((text, index) => {
                  TweenMax.to(text, 0.8, {
                    opacity: 1,
                    y: 0,
                    delay: index * 0.1,
                    ease: Power2.easeOut
                  });
                });
              } else if (progress <= 0.5) {
                this.isExpanded = false;
                document.querySelectorAll(".swiper-text").forEach(text => {
                  TweenMax.to(text, 0.2, {
                    opacity: 0,
                    y: 20,
                    ease: Power2.easeOut
                  });
                });
              }
            }
          });
        }
      },
      toggle() {
        if (this.isOpen) {
          window.scrollTo({
            top: this.scrollPosition
          });
        } else {
          this.scrollPosition = window.scrollY;
        }
        this.isOpen = !this.isOpen;
      }
    }
  };
</script>
<style scoped>
  .key-visual {
    position: relative;
    min-height: 1000px;
    height: 100vh;
    min-width: 1264px;
    .mask {
      height: 100vh;
      position: relative;
      overflow: hidden;
    }
    .contents {
      position: relative;
      z-index: 2;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      justify-content: center;
      align-items: flex-start;
      height: 100vh;
      min-height: 800px;
    }
    .bg {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background: url(../../assets/images/marketing/img_marketing_main.png) center center / cover no-repeat;
    }
    .txt {
      margin-top: 120px;
      height: 540px;
      padding-left: 20px;
      left: 0;
      top: 0;
      font-weight: 700;
      font-size: 70px;
      color: #fff;
      line-height: 100px;
      letter-spacing: -0.03em;

      span {
        font-family: "Montserrat", sans-serif;
      }
    }
  }
  .cont-title {
    margin-top: 180px;
    font-weight: 700;
    font-size: 48px;
    line-height: 74px;
    color: #000;
    letter-spacing: -0.05em;
  }
  .cont-desc {
    font-weight: 400;
    font-size: 24px;
    line-height: 34px;
    letter-spacing: -0.5px;
    margin-top: 30px;
  }

  .section {
    &.section-1 {
      margin-top: 180px;

      .process-cont {
        width: 100%;
        border-top: 1px solid #ddd;
        margin: 100px auto 0;
        padding: 50px 0 0;
        display: flex;

        .tit-wrap {
          width: calc(100% - 640px);

          p {
            font-size: 24px;
            font-weight: bold;
            letter-spacing: -0.4px;
            font-family: "Montserrat", sans-serif;
          }
        }

        .li-wrap {
          width: 640px;

          li {
            padding: 50px 0;
            border-bottom: 1px solid #ddd;

            &:first-child {
              padding: 0 0 50px;
            }

            &:last-child {
              border-bottom: none;
            }

            .li-tit {
              font-size: 24px;
              font-weight: bold;
              letter-spacing: -0.4px;
              font-family: "Montserrat", sans-serif;
              display: flex;
              align-items: center;

              span {
                font-size: 20px;
                color: #EE2C3C;
                letter-spacing: 0;
                padding-right: 8px;
                font-family: "Montserrat", sans-serif;
              }
            }

            img {
              display: block;
              margin: 30px auto;
            }

            .li-desc {
              font-size: 16px;
              letter-spacing: -0.4px;
              color: #666;
              line-height: 24px;
              word-break: keep-all;
            }
          }
        }
      }
    }
    .section-tit {
      //margin-top: 20px;
      color: #101010;
      font-size: 48px;
      font-weight: 700;
      line-height: 145%;
      font-family: "Montserrat", sans-serif;
      span {
        position: relative;
        color: #ee2c3c;
      }
    }
    .section-desc {
      margin-top: 30px;
      color: #101010;
      font-size: 24px;
      font-weight: 400;
      line-height: 34px;
      letter-spacing: -0.3px;
    }
    .section-img {
      margin:100px auto 0;
    }
  }
  .lottie-cont {
    position: relative;
    width: 100%;
    margin-top: 40px;
    &.lottie01 {
      height: 100%;
      .lottie-container {
        height: 100%;
      }
    }
  }
  .swiper-section {
    width: 100vw;
    height: 100vh;
    position: relative;
    margin: 0 auto;
    overflow: hidden;
    .swiper-button-next,
    .swiper-button-prev {
      position: absolute;
      top: calc(50% - 30px);
      //transform: translateY(-50%);
      z-index: 10;
      width: 60px;
      height: 60px;
      backdrop-filter: blur(200px);
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      &:after {
        display: none !important;
      }
    }
    .swiper-button-prev {
      left: 80px !important;
    }
    .swiper-button-next {
      transform: rotate(180deg);
      right: 80px !important;
    }
    .swiper-slide {
      display: flex;
      justify-content: center;
      will-change: clip-path;
    }
    .inner {
      column-gap: 120px;
      padding: 27.7vh 0 0 0;
      display: flex;
    }
    .logo {
      font-size: 0;
      text-indent: -9999px;
      width: 400px;
      height: 110px;
    }
    .swiper-container {
      width: 100%;
      height: 100%;

      .swiper-slide {
        display: flex;
        justify-content: center;
        will-change: clip-path;

        .inner {
          column-gap: 120px;
          padding: 27.7vh 0 0 0;
          display: flex;
          .logo {
            font-size: 0;
            text-indent: -9999px;
            width: 400px;
            height: 110px;
          }
          .right {
            width: 640px;
            .title {
              color: #fff;
              font-family: "Noto Sans KR", sans-serif;
              font-size: 48px;
              font-weight: 300;
              line-height: 130%;
              letter-spacing: -2.4px;
              strong {
                font-weight: 700;
                display: block;
              }
            }
            .sm-tit {
              margin-top: 72px;
              padding-top: 20px;
              color: #fff;
              font-family: Montserrat, "Noto Sans KR", sans-serif;
              font-size: 18px;
              font-weight: 700;
              line-height: 26px;
              letter-spacing: -0.9px;
              border-top: 1px solid rgba(255, 255, 255, 0.5);
            }
            .sm-txt {
              margin-top: 10px;
              color: #fff;
              font-family: "Noto Sans KR", sans-serif;
              font-size: 18px;
              font-weight: 400;
              line-height: 28px;
              letter-spacing: -0.9px;
              word-break: keep-all;
            }
          }
        }
      }
    }
    .swiper-text {
      opacity: 0;
    }
  }
  ::v-deep(.modal-content .modal-title span) {
    opacity: 0.5;
    font-weight: 400;
  }

  .tab-wrap {
    margin-top: 100vh;
  }
  ::v-deep .tab-top {
    .tab-list {
      ul {
        width: 344px;
      }
    }
  }
  .tab-contents {
    padding: 150px 0 0;
  }
  .marketing-wrap .contents {
    padding: 0 20px 240px;
  }
</style>
